import { render } from "./DirectorApprovedTQAndTOS.vue?vue&type=template&id=ea47e0d8"
import script from "./DirectorApprovedTQAndTOS.vue?vue&type=script&lang=js"
export * from "./DirectorApprovedTQAndTOS.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__